import { RescheduleHistory } from '../../../types/history';
import { showTimeIn12HrsFormat } from '../../../utils/timeAndDate';
import AcademiaSectionWrapper from '../AcademiaSectionWrapper';
import ModalTitle from './ModalTitle';
import ParentModal from './ParentModal';

const RescheduleHistoryModal = ({
  rescheduleHistory,
  handleModalClose,
}: {
  rescheduleHistory: RescheduleHistory;
  handleModalClose: () => void;
}) => {
  // destructuring reschedule history object here
  const {
    prev_associate_full_name,
    new_associate_full_name,
    reschedule_date,
    new_start_time,
    new_end_time,
    previous_date,
    previous_start_time,
    previous_end_time,
    reason_for_rescheduling,
    reschedule_status,
  } = rescheduleHistory || {};

  // rendering reschedule history modal component here
  return (
    <ParentModal onClick={handleModalClose}>
      <ModalTitle titleText='reschedule details' />

      <div className='space-y-8'>
        <div className='flex items-center justify-end'>
          <p
            className={`text-base-white text-sm font-semibold capitalize px-4 py-1 rounded-lg ${
              reschedule_status === 'pending'
                ? 'bg-base-orange'
                : reschedule_status === 'rejected'
                ? 'bg-base-red'
                : 'bg-base-cyan'
            }`}
          >
            {reschedule_status}
          </p>
        </div>

        <AcademiaSectionWrapper sectionTitle='Previous Details'>
          <h3 className='font-medium text-xl text-base-dark-blue'>
            {prev_associate_full_name}
          </h3>

          <div className='mt-1'>
            <div className='grid grid-cols-[130px_8px_1fr] text-base-dark-green text-sm'>
              <p>Appointment Date</p>

              <p>:</p>

              <p className='font-medium'>{previous_date}</p>
            </div>

            <div className='grid grid-cols-[130px_8px_1fr] text-base-dark-green text-sm'>
              <p>Appointment Slot</p>

              <p>:</p>

              <p className='font-medium'>
                {`${showTimeIn12HrsFormat(
                  previous_start_time
                )} - ${showTimeIn12HrsFormat(previous_end_time)}`}
              </p>
            </div>
          </div>
        </AcademiaSectionWrapper>

        <AcademiaSectionWrapper sectionTitle='Current Details'>
          <h3 className='font-medium text-xl text-base-dark-blue'>
            {new_associate_full_name}
          </h3>

          <div className='mt-1'>
            <div className='grid grid-cols-[130px_8px_1fr] text-base-dark-green text-sm'>
              <p>Appointment Date</p>

              <p>:</p>

              <p className='font-medium'>{reschedule_date}</p>
            </div>

            <div className='grid grid-cols-[130px_8px_1fr] text-base-dark-green text-sm'>
              <p>Appointment Slot</p>

              <p>:</p>

              <p className='font-medium'>
                {`${showTimeIn12HrsFormat(
                  new_start_time
                )} - ${showTimeIn12HrsFormat(new_end_time)}`}
              </p>
            </div>
          </div>
        </AcademiaSectionWrapper>

        <AcademiaSectionWrapper sectionTitle='Reason'>
          <p className='text-base-dark-blue'>{reason_for_rescheduling}</p>
        </AcademiaSectionWrapper>
      </div>
    </ParentModal>
  );
};

export default RescheduleHistoryModal;
